<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <strong>Habilitar PMAU</strong>
          </header>
          <div class="card-body">
            <p class="text-muted mb-4">
              Habilite ou desabilite o módulo PMAU para as contas às quais você
              está vinculado.
            </p>

            <div v-if="loading" class="loading-container">
              <RotateSquare
                size="60px"
                class="loading-position animated fadeIn"
              ></RotateSquare>
            </div>
            <b-table
              v-else
              :items="contas"
              :fields="fields"
              responsive
              striped
              hover
              show-empty
              empty-text="Nenhuma conta vinculada."
            >
              <template v-slot:cell(conta)="data">
                <span class="d-block font-weight-bold">
                  {{ data.item.nome_fantasia }}
                </span>
                <small class="text-muted">{{ data.item.apelido }}</small>
                <b-badge
                  v-if="data.item.conta_id === contaSelecionadaId"
                  variant="info"
                  class="ml-2"
                >
                  Conta atual
                </b-badge>
              </template>
              <template v-slot:cell(status)="data">
                <b-badge :variant="data.item.habilitado ? 'success' : 'secondary'">
                  {{ data.item.habilitado ? "Habilitado" : "Desabilitado" }}
                </b-badge>
              </template>
              <template v-slot:cell(habilitado)="data">
                <b-form-checkbox
                  v-model="data.item.habilitado"
                  switch
                  :disabled="salvando === data.item.conta_id"
                  @change="Alterar(data.item, $event)"
                ></b-form-checkbox>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import PmauService from "../../servico/PmauService";

export default {
  name: "PmauContas",
  components: { RotateSquare },
  data() {
    return {
      loading: false,
      salvando: null,
      contas: [],
      fields: [
        { key: "conta", label: "Conta" },
        { key: "status", label: "Status" },
        { key: "habilitado", label: "PMAU habilitado" }
      ]
    };
  },
  computed: {
    contaSelecionadaId() {
      const auth = this.$store.getters.getAutenticacao;
      return auth && auth.contaSelecionada ? auth.contaSelecionada.id : null;
    }
  },
  beforeMount() {
    this.CarregarContas();
  },
  methods: {
    CarregarContas() {
      this.loading = true;
      PmauService.ListAdminContas()
        .then((r) => {
          this.contas = r.data;
        })
        .catch((e) => {
          this.$notify({ data: [this.MensagemErro(e)], type: "error" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async Alterar(item, habilitado) {
      if (!habilitado) {
        const confirmado = await this.$bvModal.msgBoxConfirm(
          `Desabilitar o PMAU para "${item.nome_fantasia}"? Todos os usuários dessa conta perderão o acesso ao módulo.`,
          {
            title: "Desabilitar PMAU",
            okVariant: "danger",
            okTitle: "Desabilitar",
            cancelTitle: "Cancelar",
            centered: true
          }
        );
        if (!confirmado) {
          item.habilitado = true;
          return;
        }
      }

      this.salvando = item.conta_id;
      PmauService.SetPmauAccess(item.conta_id, habilitado)
        .then(() => {
          if (item.conta_id === this.contaSelecionadaId) {
            this.$store.commit("set_pmau_habilitado", habilitado);
          }
          this.$notify({
            data: [habilitado ? "PMAU habilitado." : "PMAU desabilitado."],
            type: "success"
          });
        })
        .catch((e) => {
          item.habilitado = !habilitado;
          this.$notify({ data: [this.MensagemErro(e)], type: "error" });
        })
        .finally(() => {
          this.salvando = null;
        });
    },
    MensagemErro(e) {
      return (e.response && e.response.data && e.response.data.detail) || e.message;
    }
  }
};
</script>
